<template>
  <div class="row">
    <div class="col">
      <div class="card">
        <h2>Rewards & How to Improve</h2>
        <p class="helper">This page explains exactly how you earn incentives and how to lift your payout.</p>
        <ul>
          <li><b>Benefits Unlock (Most Important):</b> Incentives activate once you reach <b>80% of your monthly target</b>. Track progress daily—close the gap early.</li>
          <li><b>Per-Order Discounts:</b> Smaller discounts → higher incentive rate. Keep discount ≤ 25%.</li>
          <li><b>Ticket Size:</b> Bigger orders unlock higher per-order rates (no incentive below ₹3L).</li>
          <li><b>Monthly Target Incentive:</b> Paid on total monthly sales at stepped rates from 0.15% to 0.75% as you hit 80% → 120% of target.</li>
          <li v-if="isManager"><b>Manager Expense Bonus:</b> If branch gate passes and total expenses ≤ 2.5% of branch monthly sales → bonus = 2.5% of sales.</li>
        </ul>
      </div>
    </div>

    <div class="col">
      <div class="card">
        <h3>What to do today</h3>
        <ol>
          <li>Prioritise deals ≥ ₹3L to activate ticket-size incentives.</li>
          <li>Aim to keep discounts under 10% where possible; ≤5% earns the best rate.</li>
          <li>Track your monthly progress daily to ensure you cross the 80% gate early.</li>
          <li v-if="isManager">Monitor expenses; keep below 2.5% to unlock the expense bonus.</li>
        </ol>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  computed:{ ...mapGetters('auth', ['currentUser']), isManager(){ return this.currentUser && this.currentUser.role==='branch_manager' } }
}
</script>